
// AUTH END POINTS

export const API_END_POINT_LOGIN: string = 'login'
export const API_END_POINT_LOGIN_ADMIN: string = 'login-admin'
export const API_END_POINT_LOGIN_APP: string = 'login-app'
export const API_END_POINT_REQUEST_PASSWORD_RESET: string = 'request-password-reset'
export const API_END_POINT_PASSWORD_RESET: string = 'app-password-reset'

export const API_END_POINT_REGISTER: string = 'register'
export const API_END_POINT_APP_REGISTER: string = 'register-app'
export const API_END_POINT_INSTRUCTOR_REGISTER: string = 'instructor-register'

// SEARCH

export const API_END_POINT_INSTRUCTOR_SEARCH: string = 'instructor-search'

// Verify Email

export const API_END_POINT_VERIFY_EMAIL: string = 'verify-email'
export const API_END_POINT_VERIFY_INSTRCUTOR_EMAIL: string = 'verify-instructor-email'

// Update requests

export const API_END_POINT_UPDATE_CUSTOMER_DATA: string = 'update-customer-data'
export const API_END_POINT_UPDATE_CUSTOMER_PROFILE_PIC: string = 'update-customer-profile-pic'

export const API_END_POINT_UPDATE_USER_DATA: string = 'update-user-data'
export const API_END_POINT_UPDATE_USER_PROFILE_PIC: string = 'update-user-profile-pic'
export const API_END_POINT_UPDATE_USER_HERO_PIC: string = 'update-user-hero-pic'

export const API_END_POINT_UPDATE_INSTRUCTOR_DATA: string = 'update-instructor-data'
export const API_END_POINT_UPDATE_INSTRUCTOR_PROFILE_PIC: string = 'update-instructor-profile-pic'
export const API_END_POINT_UPDATE_INSTRUCTOR_HERO_PIC: string = 'update-instructor-hero-pic'

// Customer

export const API_END_POINT_GET_CUSTOMER_DETAILS: string = 'get-customer-details'
export const API_END_POINT_GET_ALL_CUSTOMER_DETAILS: string = 'get-all-customer-details'
export const API_END_POINT_GET_CUSTOMER_INTERACTIONS: string = 'get-customer-interactions'

// Instructor

export const API_END_POINT_GET_INSTRUCTOR_DETAILS: string = 'get-instructor-details'
export const API_END_POINT_GET_ALL_INSTRUCTOR_DETAILS: string = 'get-all-instructor-details'
export const API_END_POINT_GET_INSTRUCTOR_USER_DATA: string = 'get-instructor-user-data'
export const API_END_POINT_GET_INSTRUCTOR_PROFILE_DATA: string = 'get-instructor-profile-data'
export const API_END_POINT_GET_INSTRUCTOR_INTERACTIONS: string = 'get-instructor-interactions'

// Interactions

export const API_END_POINT_GET_INTERACTIONS: string = 'get-interactions'
export const API_END_POINT_GET_ALL_INTERACTIONS: string = 'get-all-interactions'
export const API_END_POINT_UPDATE_INTERACTION_STATUS: string = 'update-interaction-status'
export const API_END_POINT_UPDATE_INTERACTION_DATA: string = 'update-interaction-data'
export const API_END_POINT_INTERACTION_INSTRUCTOR_MESSAGE: string = 'interaction-add-instructor-message'
export const API_END_POINT_INTERACTION_INSTRUCTOR_VIDEO: string = 'interaction-add-instructor-video'
export const API_END_POINT_CREATE_NEW_VIDEO_INTERACTION: string = 'create-new-video-interaction'


export const API_END_POINT_COMPLETE_TIP: string = 'complete-tip'
export const API_END_POINT_COMPLETE_TRANSACTION: string = 'complete-transaction'
export const API_END_POINT_TIP_INTERACTION: string = 'tip-interaction'

// Reviews

export const API_END_POINT_CREATE_NEW_REVIEW: string = 'create-new-review'
export const API_END_POINT_GET_INSTRUCTORS_REVIEWS: string = 'get-instructors-reviews'

export const API_END_POINT_GET_ANALYSIS_DATA: string = 'get-analysis-data'

// Communities

export const API_END_POINT_GET_ALL_COMMUNITIES: string = 'get-all-communities'
export const API_END_POINT_GET_COMMUNITIES_FOR_USER: string = 'get-communities-for-user'

export const API_END_POINT_JOIN_COMMUNITY: string = 'join-community'
export const API_END_POINT_LEAVE_COMMUNITY: string = 'leave-community'

// Posts

export const API_END_POINT_CREATE_NEW_POST: string = 'create-new-post' // json data - user_id, post_title, post_str, post_img, community_id
export const API_END_POINT_CREATE_NEW_COMMENT: string = 'create-new-comment' // json data - user_id, post_id, comment_str

export const API_END_POINT_LIKE_POST: string = 'like-post'
export const API_END_POINT_UNLIKE_POST: string = 'unlike-post'
export const API_END_POINT_GET_LIKES_FOR_USER: string = 'get-likes-for-user'

export const API_END_POINT_GET_ALL_POSTS: string = 'get-all-posts'
export const API_END_POINT_GET_POSTS_FOR_USER: string = 'get-posts-for-user' // returns users posts and posts in communities they belong too
export const API_END_POINT_GET_USER_POSTS: string = 'get-user-posts' // returns a list of posts made by the user
export const API_END_POINT_GET_POSTS_FOR_COMMUNITY: string = 'get-posts-for-community'
export const API_END_POINT_GET_POSTS_FOR_COMMUNITY_OWNER: string = 'get-posts-for-community-owner'

export const API_END_POINT_GET_COMMENTS_FOR_POST: string = 'get-comments-for-post'

// Users

export const API_END_POINT_GET_DATA_FOR_USER: string = 'get-data-for-user'

export const API_END_POINT_GET_USER_FOLLOWS: string = 'get-follows-for-user'
export const API_END_POINT_GET_FOLLOW_USERS: string = 'get-users-for-follows'
export const API_END_POINT_FOLLOW_USER: string = 'follow-user'
export const API_END_POINT_UNFOLLOW_USER: string = 'unfollow-user'
